import PayOverTimeStatementPdfScreen from 'features/payOverTime/screens/PayOverTimeStatements/PayOverTimeStatementPdfScreen';

export default function ReactivationPayOverTimeStatementPdfPage() {
  return <PayOverTimeStatementPdfScreen />;
}
